import { ATTACHED_FILE_TYPE } from '@/api/type/commonTypes';
import { Images } from '@/assets';
import { FileTransferService } from '@/libs/r2-service-client';
import { fonts } from '@/theme/fonts';
import { formatFileSize } from '@/utils/file/formatFileSize';
import { useCallback } from 'react';
import styled from 'styled-components';

interface BusinessFileListProps {
  fileList: ATTACHED_FILE_TYPE[];
}

const BusinessFileList = ({ fileList }: BusinessFileListProps) => {
  const onHandleDownload = useCallback(
    (item: ATTACHED_FILE_TYPE) => async () => {
      const response = await fetch(FileTransferService.getDownloadUri(item.id));
      if (!response.ok) {
        throw new Error('파일 다운로드 실패');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = item.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    []
  );

  return (
    <ListBox>
      {fileList.length > 0 &&
        fileList.map((item) => (
          <UploadItem key={item.id}>
            <FileName>{item.name}</FileName>
            <DeleteWrap>
              <FileName>{formatFileSize(item.size)}</FileName>
              <DownloadButton onClick={onHandleDownload(item)} />
            </DeleteWrap>
          </UploadItem>
        ))}
    </ListBox>
  );
};

export default BusinessFileList;

const ListBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
`;

const UploadItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
`;

const FileName = styled.div`
  flex: 1;
  font-family: ${fonts.family.inter};
  font-size: 14px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DeleteWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

const DownloadButton = styled.button`
  width: 20px;
  height: 20px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${Images.DownloadIcon});
`;
